@if (loadingData() || imagesToLoad() > 0) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
  <div style="height: 4px"></div>
}

@let geometryValue = geometry();
@let zoomLevelValue = zoomLevel();
@let mapTypeValue = mapType();
@let parameterValue = parameter();
<mgl-map
  [class]="mapTypeValue == MapType.RADAR ? 'radar-map' : 'aspect-ratio-element'"
  #mapbox
  [id]="mapTypeValue"
  [style]="style"
  [accessToken]="mapboxAccessToken"
  [zoom]="[zoomLevelValue]"
  [bounds]="mapTypeValue === mapTypes.RADAR ? null : bounds"
  [fitBoundsOptions]="{ padding: boundsPadding }"
  [dragPan]="true"
  [center]="zoomPointCoordinates"
  [scrollZoom]="true"
  [pitchWithRotate]="false"
  [dragRotate]="false"
  [touchZoomRotate]="false"
  [cooperativeGestures]="true"
  [maxTileCacheSize]="48"
  [refreshExpiredTiles]="false"
  [minZoom]="minMapZoom"
  [maxZoom]="maxMapZoom"
  [maxBounds]="maxBounds"
  [attributionControl]="false"
  (mapCreate)="onMapCreate($event)"
  (mapLoad)="onMapLoad($event)"
  (mapClick)="onMapClick($event)"
  [preserveDrawingBuffer]="true">
  <!-- background -->
  <mgl-layer
    type="background"
    id="app-background"
    [paint]="backgroundPaintStyle"></mgl-layer>

  <!--
  <mgl-vector-source id="mapbox" [url]="'mapbox://mapbox.mapbox-street-v8"></mgl-vector-source>
  <mgl-layer id="streets" source="mapbox" sourceLayer="road" type="line"></mgl-layer>
  <mgl-layer id="places" source="mapbox" sourceLayer="place_label" type="symbol"></mgl-layer>
  -->
  <!-- <mgl-vector-source [id]="'mapbox'" url="mapbox://mapbox.mapbox-streets-v8"></mgl-vector-source> -->
  <!--  <mgl-layer id="streets" [source]="'mapbox'" sourceLayer="road" type="line"></mgl-layer> -->

  <mgl-control
    mglNavigation
    [showZoom]="true"
    [showCompass]="false"></mgl-control>
  <mgl-control mglFullscreen></mgl-control>

  <!-- <mgl-control position="top-right"> -->
  <!-- TODO: allow selection of layer for satellite once it works-->
  <!-- @if(!(mapTypeValue === mapTypes.SATELLITE)) {
  <div class="mapboxgl-ctrl-group">
      <button
        type="button"
        aria-label="Select layer"
        (click)="showLayerSelect = !showLayerSelect">
        <fa-icon [icon]="['far', 'layer-group']" size="lg"></fa-icon>
      </button>
    </div>
  }-->
  <!--
    <button mat-mini-fab class="mgl-map__select-layer-button" (click)="showLayerSelect = !showLayerSelect">
      <fa-icon [icon]="['far', 'layer-group']"></fa-icon>
    </button>
    -->
  <!-- </mgl-control> -->

  <!-- map layer select
   @if(showLayerSelect) {
  <mgl-control position="top-right">
    <mat-card appearance="outlined" class="mgl-map__layer-select">
      <div class="mgl-map__layer-select-header">
        <div class="mgl-map__layer-select-header-text wm-subheading-2">
          {{ 'MAP.SELECT_BACKGROUND' | translate }}
        </div>
        <button mat-icon-button (click)="showLayerSelect = false">
          <fa-icon [icon]="['far', 'times']"></fa-icon>
        </button>
      </div>
      <mat-selection-list style="padding-top: 0">
        @for(mapLayer of mapLayers; track $index) {
          <mat-list-option
            style="height: auto"
            [selected]="mapLayer.name === getActiveMapLayer()['name']"
            (click)="setActiveMapLayer(mapLayer['name'])"
            role="option">
            <img
              [src]="'/assets/images/map-background/' + mapLayer.name + '.png'"
              matListItemIcon />
            <div class="wm-subheading-2" matListItemLine>
              {{ 'MAP.' + mapLayer.name + '.TITLE' | translate }}
            </div>
            <p matListItemLine>
              {{ 'MAP.' + mapLayer.name + '.DESCRIPTION' | translate }}
            </p>
          </mat-list-option>
        }
      </mat-selection-list>
    </mat-card>
  </mgl-control>
 } -->
  @let dtgsValue = dtgs();
  @let dtgIndexValue = dtgIndex();
  <!-- radar layer -->
  @if (mapTypeValue === mapTypes.RADAR && dtgsValue) {
    <app-radar-map-layers
      [dtgs]="dtgsValue"
      [dtgIndex]="dtgIndexValue"
      [region]="region()"
      [showCellTracking]="showCellTracking()"
      [radarPaintVisible]="radarPaintVisible"
      [radarPaintInvisible]="radarPaintInvisible">
    </app-radar-map-layers>

    <app-radar-distance-circles
      [zoomLevel]="zoomLevelValue"
      [geometry]="geometryValue"
      [labels]="labels()"
      [circlePaint]="circlePaint"
      [styleName]="styleName">
    </app-radar-distance-circles>
  }

  <!-- routefcst layer -->
  @let routeTileValue = routeTile();
  @if (
    mapTypeValue === mapTypes.ROUTEFCST &&
    dtgsValue.length > 0 &&
    routeTileValue
  ) {
    @if (dtgsValue.length > dtgIndexValue) {
      <mgl-control position="top-left">
        <div class="dtg-control">{{ dtgsValue[dtgIndexValue].info }}</div>
      </mgl-control>
    }

    <!-- route -->
    @if (routeTileValue) {
      <mgl-raster-source
        [id]="'route'"
        [tiles]="[routeTileValue]"
        [tileSize]="1024"
        [bounds]="maxBounds"
        [maxzoom]="13">
      </mgl-raster-source>

      <mgl-layer
        [id]="'route'"
        [source]="'route'"
        type="raster"
        [paint]="$any(radarPaintVisible)">
      </mgl-layer>
    }

    <!-- mos layer -->
    @let stationTileValue = stationTile();
    @if (stationTileValue) {
      <mgl-raster-source
        [id]="'mos'"
        [tiles]="[stationTileValue]"
        [tileSize]="1024"
        [bounds]="maxBounds"
        [maxzoom]="13"></mgl-raster-source>

      <mgl-layer
        [id]="'mos'"
        [source]="'mos'"
        type="raster"
        [paint]="$any(radarPaintVisible)">
      </mgl-layer>
    }

    @let addressPopupValue = addressPopup();
    @if (addressPopupValue && addressPopupValue.position) {
      <mgl-popup
        [lngLat]="addressPopupValue.position"
        [closeOnClick]="true"
        anchor="center">
        <div class="address-popup">
          <h3>{{ addressPopupValue.street }}</h3>
          @if (addressPopupValue.eopData) {
            <table class="popup-table">
              @let testModeValue = routeFcstService.testMode();
              @let ttValue =
                'ttt'
                  | getEopValue
                    : addressPopupValue
                    : dtgsValue
                    : dtgIndexValue
                    : testModeValue;
              @if (ttValue) {
                <tr>
                  <td><span appWmIcon [inputParameter]="'tt'"></span></td>
                  <td>{{ ttValue }}°C</td>
                </tr>
              }
              @let tdValue =
                'td'
                  | getEopValue
                    : addressPopupValue
                    : dtgsValue
                    : dtgIndexValue
                    : testModeValue;
              @if (tdValue) {
                <tr>
                  <td><span appWmIcon [inputParameter]="'td'"></span></td>
                  <td>{{ tdValue }}°C</td>
                </tr>
              }
              @let troadValue =
                'troad'
                  | getEopValue
                    : addressPopupValue
                    : dtgsValue
                    : dtgIndexValue
                    : testModeValue;
              @if (troadValue) {
                <tr>
                  <td><span appWmIcon [inputParameter]="'road_tt'"></span></td>
                  <td>{{ troadValue }}°C</td>
                </tr>
              }
              @let roadconditionValue =
                'roadcondition'
                  | getEopValue
                    : addressPopupValue
                    : dtgsValue
                    : dtgIndexValue
                    : testModeValue;
              @if (roadconditionValue) {
                <tr>
                  <td>
                    <span appWmIcon [inputParameter]="'road_condition'"></span>
                  </td>
                  <td>
                    {{
                      'MAPPING.EOP_ROAD_CONDITION.' + roadconditionValue
                        | translate
                    }}
                  </td>
                </tr>
              }
            </table>
          }
        </div>
      </mgl-popup>
    }
  }

  @let geoJsonValue = geoJson();
  @let marwisFeatureValue = marwisFeature();
  <!-- marwis layer -->
  @if (mapTypeValue === mapTypes.MARWIS && geoJsonValue) {
    <mgl-geojson-source
      [id]="'marwis'"
      [data]="geoJsonValue"
      [cluster]="true"
      [clusterRadius]="5"
      [clusterProperties]="marwisClusterProperties">
    </mgl-geojson-source>
    <mgl-layer
      [id]="'marwis'"
      [source]="'marwis'"
      type="circle"
      [paint]="marwisPaint"
      (layerClick)="onMarwisClick($event)"
      (layerMouseEnter)="onMarwisMouseEnter($event)"
      (layerMouseLeave)="onMarwisMouseLeave($event)"></mgl-layer>

    <!-- marker -->
    @if (
      geoJsonValue &&
      geoJsonValue.hasOwnProperty('features') &&
      geoJsonValue.features.length > 0 &&
      marwisFeatureValue
    ) {
      <!-- start marker -->
      <mgl-marker [feature]="geoJsonValue.features[0]" class="marwis-start">
        <fa-layers size="3x" [fixedWidth]="true">
          <fa-icon [icon]="['fas', 'circle']" style="color: white"></fa-icon>
          <fa-icon
            [icon]="['far', 'home']"
            transform="shrink-6"
            style="color: #4b4b4b"></fa-icon>
        </fa-layers>
      </mgl-marker>

      <!-- end marker -->
      <mgl-marker
        [feature]="geoJsonValue.features[geoJsonValue.features.length - 1]"
        class="marwis-end">
        <fa-layers size="3x" [fixedWidth]="true">
          <fa-icon [icon]="['fas', 'circle']" style="color: white"></fa-icon>
          <fa-icon
            [icon]="['far', 'flag']"
            transform="shrink-6"
            style="color: #4b4b4b"></fa-icon>
        </fa-layers>
      </mgl-marker>

      <!-- car position -->
      <mgl-marker [feature]="marwisFeatureValue" class="marwis-car">
        <fa-layers size="3x" [fixedWidth]="true" [ngStyle]="{ zIndex: 5 }">
          <fa-icon [icon]="['fas', 'circle']" style="color: white"></fa-icon>
          <fa-icon
            [icon]="['far', 'car']"
            transform="shrink-4"
            style="color: #399de6"></fa-icon>
        </fa-layers>
      </mgl-marker>
    }

    @let marwisPopupValue = marwisPopup();
    @if (marwisPopupValue && marwisPopupValue.position) {
      <mgl-popup
        [lngLat]="marwisPopupValue.position"
        [closeOnClick]="true"
        anchor="top"
        style="z-index: 6">
        <div class="address-popup">
          <h3>
            {{
              marwisPopupValue.dtg
                | datex
                  : 'DD.MM.YYYY HH:mm'
                  : undefined
                  : languageService.langSignal()
            }}
          </h3>
          <p>
            {{ 'PRODUCT.MARWIS.PARAMETER.' + parameterValue | translate }}:
            <ng-container
              *ngTemplateOutlet="
                marwisValue;
                context: { $implicit: marwisPopupValue.value }
              "></ng-container>
          </p>
        </div>
      </mgl-popup>
    }
  }

  <!-- pigeon layer -->
  @if (mapTypeValue === mapTypes.PIGEONS) {
    HELLO
    <mgl-image
      id="flag-end"
      url="/assets/images/flag-checkered-solid.png"
      (imageLoaded)="increaseLoadedIcons()"></mgl-image>
    @for (i of [0, 1, 2, 3, 4, 'x']; track $index) {
      <mgl-image
        [id]="'flag-' + i"
        [url]="'/assets/images/flag-' + i + '.png'"
        (imageLoaded)="increaseLoadedIcons()"></mgl-image>
    }

    @if (fullScreenMode()) {
      <mgl-control position="top-left">
        <div class="mapboxgl-ctrl-group pigeon-parameters">
          @for (param of pigeonParameters | key; track $index) {
            <button
              mat-icon-button
              (click)="onPigeonParameterChange(param)"
              [ngClass]="param === parameterValue ? 'active-button' : ''">
              <fa-icon
                [icon]="[
                  param === parameterValue ? 'fas' : 'far',
                  pigeonParameters[param].icon,
                ]"
                size="lg"></fa-icon>
            </button>
          }
        </div>
        <div class="dtg-control-pigeons">
          {{
            dtgsValue.length > dtgIndexValue
              ? dtgsValue[dtgIndexValue].info
              : ''
          }}
        </div>
        <div class="mapboxgl-ctrl-group pigeon-hour-buttons">
          @for (hour of pigeonHours(); track $index) {
            <button
              (click)="onPigeonHourChange(hour)"
              [ngClass]="
                hour === dtgIndexValue + pigeonsService.startHour
                  ? 'active-button'
                  : ''
              ">
              {{ hour | number: '2.0-0' }}:00
            </button>
          }
        </div>
      </mgl-control>
    }
    @let pigeonShowTileAroundValue = pigeonShowTileAround();
    @let pigeonTilePlacesValue = pigeonTilePlaces();
    @if (!pigeonShowTileAroundValue && pigeonTilePlacesValue) {
      <mgl-raster-source
        [id]="'route'"
        [tiles]="[pigeonTilePlacesValue]"
        [tileSize]="1024"
        [bounds]="maxBounds"
        [maxzoom]="10">
      </mgl-raster-source>

      <mgl-layer
        [id]="'route'"
        [source]="'route'"
        type="raster"
        [paint]="$any(radarPaintVisible)">
      </mgl-layer>
    }

    @let pigeonTileDestinationValue = pigeonTileDestination();
    @if (!pigeonShowTileAroundValue && pigeonTileDestinationValue) {
      <mgl-raster-source
        [id]="'destination'"
        [tiles]="[pigeonTileDestinationValue]"
        [tileSize]="1024"
        [bounds]="maxBounds"
        [maxzoom]="10">
      </mgl-raster-source>

      <mgl-layer
        [id]="'destination'"
        [source]="'destination'"
        type="raster"
        [paint]="$any(radarPaintVisible)">
      </mgl-layer>
    }

    @let pigeonTileAroundValue = pigeonTileAround();
    @if (pigeonShowTileAroundValue && pigeonTileAroundValue) {
      <mgl-raster-source
        [id]="'around'"
        [tiles]="[pigeonTileAroundValue]"
        [tileSize]="512"
        [bounds]="maxBounds"
        [maxzoom]="7">
      </mgl-raster-source>

      <mgl-layer
        [id]="'around'"
        [source]="'around'"
        type="raster"
        [paint]="$any(pigeonPaintVisible)">
      </mgl-layer>
    }

    @let pigeonRouteDetailsValue = pigeonRouteDetails();
    @let pigeonMosValue = pigeonMos();
    @if (pigeonRouteDetailsValue.geoJsonBase) {
      <!-- pigeon route -->
      <mgl-geojson-source
        [id]="'pigeonBaseRoute'"
        [data]="pigeonRouteDetailsValue.geoJsonBase">
      </mgl-geojson-source>
      @if (
        pigeonRouteDetailsValue.stations.length === 0 ||
        !pigeonMosValue.hasOwnProperty(
          pigeonRouteDetailsValue.stations[
            pigeonRouteDetailsValue.stations.length - 1
          ].stationId
        )
      ) {
        <mgl-layer
          id="pigeonBaseRoute"
          type="line"
          [source]="'pigeonBaseRoute'"
          [paint]="{
            'line-color': 'red',
            'line-width': 3,
            'line-opacity': 0.5,
          }">
        </mgl-layer>
      }

      @if (
        pigeonRouteDetailsValue.stations.length > 0 &&
        pigeonRouteDetailsValue.start.latitude !== 0
      ) {
        @let pigeonRoutePositionValue = pigeonRoutePosition();
        <!-- flag position -->
        @if (
          pigeonRoutePositionValue &&
          (pigeonRoutePositionValue | keyvalue).length > 0 &&
          pigeonRoutePositionValue.lnglat
        ) {
          <mgl-marker
            [lngLat]="
              pigeonRoutePositionValue.lnglat
                ? pigeonRoutePositionValue.lnglat
                : [0, 0]
            "
            anchor="bottom"
            [draggable]="true"
            (markerDragEnd)="onPigeonPositionChange($event)"
            style="z-index: 2">
            <fa-layers>
              <fa-icon
                [icon]="['fad', 'dove']"
                size="4x"
                [flip]="pigeonFlipIcon"
                [style.--fa-primary-color]="'black'"
                [style.--fa-secondary-opacity]="'0.9'"
                [style.--fa-secondary-color]="
                  pigeonMosValue.hasOwnProperty(
                    pigeonRoutePositionValue.station
                  )
                    ? pigeonRoutePositionValue.color
                    : 'red'
                "></fa-icon>
              <fa-icon
                [icon]="['fal', 'dove']"
                size="4x"
                [flip]="pigeonFlipIcon"
                style="color: #4b4b4b"></fa-icon>
            </fa-layers>
          </mgl-marker>
        }
      }

      @if (pigeonRouteDetailsValue.geoJsonMOS) {
        @for (
          geoJsonMOS of pigeonRouteDetailsValue.geoJsonMOS;
          track $index;
          let i = $index
        ) {
          <mgl-geojson-source [id]="'pigeonRouteMos' + i" [data]="geoJsonMOS">
          </mgl-geojson-source>
          @if (
            pigeonRouteDetailsValue.stations.length > i &&
            pigeonMosValue.hasOwnProperty(
              pigeonRouteDetailsValue.stations[i].stationId
            )
          ) {
            <mgl-layer
              [id]="'pigeonRouteMos' + i"
              [source]="'pigeonRouteMos' + i"
              type="line"
              [paint]="{
                'line-color':
                  i
                  | pigeonRoutePartColor
                    : pigeonRouteDetailsValue
                    : parameterValue
                    : pigeonStationTime()
                    : pigeonsService.startHour
                    : pigeonsService.parameterInfo
                    : pigeonMosValue
                    : dtgsValue
                    : dtgIndexValue
                    : pigeonsService.endHour
                    : pigeonsService.day()
                    : pigeonsService.mosData(),
                'line-width': 5,
                'line-opacity': 1,
              }">
            </mgl-layer>
          }
        }

        <!-- Flags as layer symbol for print -->
        @if (
          pigeonRouteDetailsValue.geoJsonFlags &&
          pigeonRouteDetailsValue.geoJsonFlags.length > 0 &&
          loadedIcons() > 5
        ) {
          <mgl-geojson-source id="pigeon-flags-source">
            @for (
              geoJsonFlag of pigeonRouteDetailsValue.geoJsonFlags;
              track $index
            ) {
              <mgl-feature
                [geometry]="geoJsonFlag.geometry"
                [properties]="geoJsonFlag.properties"></mgl-feature>
            }
          </mgl-geojson-source>

          <mgl-layer
            class="pigeon-flags"
            [id]="'flags'"
            type="symbol"
            [source]="'pigeon-flags-source'"
            [layout]="{
              'icon-image': ['get', 'icon'],
              'icon-anchor': 'bottom-left',
              'symbol-sort-key': 10,
            }">
          </mgl-layer>
        }
      }
    }

    @let pigeonPopupValue = pigeonPopup();
    @if (
      (pigeonPopupValue | keyvalue).length > 0 && pigeonPopupValue['longitude']
    ) {
      <mgl-popup
        [closeOnClick]="true"
        anchor="top"
        [lngLat]="[
          pigeonPopupValue['longitude'],
          pigeonPopupValue['latitude'],
        ]">
        <div class="address-popup">
          <h3>{{ pigeonPopupValue['name'] }} ({{ pigeonPopupValue['id'] }})</h3>
          <p>{{ pigeonPopupValue['description'] }}</p>

          @if (pigeonPopupValue['type'] === 'start') {
            <button
              style="border: 2px solid red"
              mat-raised-button
              (click)="onPigeonNewRouteStart(pigeonPopupValue)">
              Auflassort
            </button>
          }
          &nbsp;
          @if (pigeonPopupValue['type'] === 'destination') {
            <button
              style="border: 2px solid #1e90ff"
              mat-raised-button
              (click)="onPigeonNewRouteEnd(pigeonPopupValue)">
              Zielgebiet
            </button>
          }
          &nbsp;
          <button mat-raised-button (click)="pigeonPopup.set({})">
            Abbrechen
          </button>
        </div>
      </mgl-popup>
    }
  }

  <!-- satellite layer -->
  @let satelliteImageUrlValue = satelliteImageUrl();
  @if (mapTypeValue === mapTypes.SATELLITE && satelliteImageUrlValue) {
    <mgl-image-source
      [id]="'satellite-image-source'"
      [url]="satelliteImageUrlValue"
      [coordinates]="satelliteImageCoordinates()">
    </mgl-image-source>

    <mgl-layer
      [id]="'satellite-image-layer'"
      [source]="'satellite-image-source'"
      type="raster"
      [paint]="satellitePaintStyle">
    </mgl-layer>
  }
</mgl-map>

<ng-template #marwisValue let-value>
  @if (value | isNil: false) {
    @switch (parameterValue) {
      @case ('road_tt') {
        <span>{{ value | number: '1.1-1' }}°C</span>
      }
      @case ('tt') {
        <span>{{ value | number: '1.1-1' }}°C</span>
      }
      @case ('td') {
        <span>{{ value | number: '1.1-1' }}°C</span>
      }
      @case ('rh') {
        <span>{{ value | round }}%</span>
      }
      @case ('road_rh') {
        <span>{{ value | round }}%</span>
      }
      @case ('road_condition') {
        <span>{{ 'PRODUCT.MARWIS.CONDITION.' + value | translate }}</span>
      }
      @case ('wft') {
        <span>{{ value | round }}µm</span>
      }
    }
  }
</ng-template>
